<template>
  <div class="promotion-vouchers" v-if="isLoggedIn && promotionsEnabled && getApplicableVouchers">
    <promotion-voucher v-if="applicableVouchers && applicableVouchers.length"
                       v-for="(voucher, index) in applicableVouchers"
                       :key="voucher.IDMMPRVoucher"
                       :index="index"
                       :voucher="voucher"
                       :betId="betId"
                       :tab="betslipTab"
                       :currentBetSlipState="currentBetSlipState"
                       @dismissError="dismissError" >
    </promotion-voucher>

<!--        <b>betId:</b> {{betId}}<br>-->
<!--        <hr><b>availableVouchers:</b> {{availableVouchers}}-->
<!--        <hr><b>availableVouchers len:</b> {{availableVouchers.length}}-->
<!--        <hr><b>availableVouchersTypes:</b> {{availableVouchersTypes}}-->
<!--        <hr><b>applicableVouchers:</b> {{applicableVouchers}}-->
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import promotionVoucher from './voucher'

export default {
  name: 'promotionVouchers',
  props: ['allowedBetTypesAndReturns', 'tab', 'currentBetSlipState', 'isFastBet'],
  data () {
    return {
    }
  },
  components: {
    promotionVoucher
  },
  computed: {
    betId () {
      return this.allowedBetTypesAndReturns.betId
    },
    betslipTab () {
      let tab = this.tab === 'XP' ? 'REGULAR' : this.tab
      return tab
    },
    isLoggedIn () {
      return store.getters['isLoggedIn']
    },
    promotionsEnabled () {
      return store.getters['sbBetslipState/promotionsEnabled']
    },
    getApplicableVouchers () {
      return store.getters['sbBetslipState/getApplicableVouchers']
    },
    appliedVoucher () {
      return store.getters['sbBetslipState/appliedVoucher'](this.tab)
    },
    availableVouchers () {
      return store.getters['sbBetslipState/getAvailableVouchers'] || []
    },
    availableVouchersTypes () {
      let availableVouchersTypes = this.availableVouchers.map(v => v.IDMMPRVoucherType)
      return availableVouchersTypes
    },
    promotionVouchers () {
      if (!(this.promotionsEnabled && this.getApplicableVouchers)) {
        return null
      }
      let promotionVouchers = (this.allowedBetTypesAndReturns && this.allowedBetTypesAndReturns.Vouchers) || []
      // console.log('promotionVouchers for', this.betId, ':', promotionVouchers, promotionVouchers.length)
      return promotionVouchers
    },
    applicableVouchers () {
      // console.log('Compute applicableVouchers:', this.betId, 'for Vouchers:', this.promotionVouchers, this.promotionVouchers.length)
      let availableVouchersIds = this.availableVouchers.map(v => v.IDMMPRVoucher)
      let applicableVouchers = (this.allowedBetTypesAndReturns && this.allowedBetTypesAndReturns.applicableVouchers) || []
      applicableVouchers = applicableVouchers.filter(v => v.IDMMPRVoucher && availableVouchersIds.includes(v.IDMMPRVoucher))
      //
      if (this.promotionVouchers && this.promotionVouchers.length && this.availableVouchers && this.availableVouchers.length) {
        // && !this.allowedBetTypesAndReturns.applicableVouchers
        //   console.log('DO applicableVouchersCheck for:', this.betId)
        let applicableVouchersCheck = []
        let applicableVouchersIds = applicableVouchers.map(v => v.IDMMPRVoucher)
        // console.log('applicableVouchers for', this.betId, 'of vouchers:', this.promotionVouchers.length, 'applicableVouchersIds:', applicableVouchersIds)
        for (let voucher of this.promotionVouchers) {
          let avouchers = this.availableVouchers.filter(av => {
            // console.log('av:', av)
            return av.IDMMPRVoucher && !applicableVouchersIds.includes(av.IDMMPRVoucher) && av && av.IDMMPRVoucherType === voucher.VoucherTypeId
          })
          avouchers = avouchers.map(v => {
            let voucherC = JSON.parse(JSON.stringify(voucher))
            let cv = JSON.parse(JSON.stringify(v))
            for (let p in voucherC) {
              if (p === 'Offers' && voucherC.Offers) {
                for (let offer of voucherC.Offers) {
                  if (offer.SOFilterValues) {
                    // console.log('Update UnitStakeCapping', offer.SOFilterValues.UnitStakeCapping, '=>', cv.CurrentAmount)
                    offer.SOFilterValues.UnitStakeCapping = cv.CurrentAmount || offer.SOFilterValues.UnitStakeCapping
                  }
                }
              }
              Vue.set(cv, p, voucherC[p])
            }
            return cv
          })
          applicableVouchersCheck = applicableVouchersCheck.concat(avouchers)
        }
        //
        if (applicableVouchersCheck.length) {
          applicableVouchers = applicableVouchers.concat(applicableVouchersCheck)
        }
      }
      let cv = JSON.stringify(this.allowedBetTypesAndReturns.applicableVouchers)
      let nv = JSON.stringify(applicableVouchers)
      if (nv !== cv) {
        Vue.set(this.allowedBetTypesAndReturns, 'applicableVouchers', applicableVouchers)
      }
      //
      let applicableVouchersOrdered = []
      if (availableVouchersIds && availableVouchersIds.length && applicableVouchers && applicableVouchers.length) {
        for (let id of availableVouchersIds) {
          applicableVouchersOrdered = applicableVouchersOrdered.concat(applicableVouchers.filter(v => v.IDMMPRVoucher === id))
        }
      }
      // console.log('applicableVouchers:', this.betId, ':', applicableVouchers, applicableVouchers.length, new Date().getTime())
      return applicableVouchersOrdered || applicableVouchers
    },
    isSingleBetslipActive () {
      return store.getters['overlayState/isSingleBetslipActive']
    }
  },

  methods: {
    dismissError () {
      this.$emit('dismissError', this.betId, false)
    }
  },

  created () {
  },

  mounted () {
  },

  watch: {
    applicableVouchers: {
      immediate: true,
      handler (newVal, oldVal) {
        // console.log('watch applicableVouchers for', this.betId, ':', oldVal, '=>', newVal)
        // console.log('oldVal:', JSON.stringify(oldVal))
        // console.log('newVal:', JSON.stringify(newVal))
        if (this.betId && (this.isFastBet || !this.isSingleBetslipActive)) {
          // console.log('watch applicableVouchers for', this.betId, 'isFastBet (', this.isFastBet, ') isSingleBetslipActive: ', this.isSingleBetslipActive, ':', oldVal, '=>', newVal)
          // console.log('oldVal:', JSON.stringify(oldVal))
          // console.log('newVal:', JSON.stringify(newVal))
          store.dispatch('sbBetslipState/voucherCount', {
            betId: this.betId,
            'applicableVouchersLength': this.applicableVouchers.length
          })
        }
      }
    }
  },

  destroyed () {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sports/betslipV2/promotionVouchers/vouchers.vue